import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
const BOOKS_IMG = 'https://cdn.magicpatterns.com/uploads/bhFSrSEpMQzWKRAtD8S14k/Fotografa_de_producto_de_ultra_Nano_Banana_2_93471.jpg';
export function HeroSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true
  });
  return <section className="relative overflow-hidden" style={{
    background: 'radial-gradient(ellipse at top center, rgba(212,175,55,0.08) 0%, #0D0D1A 60%, #0A0805 100%)'
  }} data-id="element-129">
      <div className="absolute inset-0 bg-center bg-no-repeat bg-cover opacity-[0.18] pointer-events-none" style={{
      backgroundImage: `url(${BOOKS_IMG})`,
      backgroundPosition: 'center 40%',
      maskImage: 'radial-gradient(ellipse at center, black 30%, transparent 75%)',
      WebkitMaskImage: 'radial-gradient(ellipse at center, black 30%, transparent 75%)'
    }} data-id="element-130" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_-20%,rgba(212,175,55,0.06),transparent_70%)]" data-id="element-131" />

      <motion.div ref={ref} initial={{
      opacity: 0
    }} animate={isInView ? {
      opacity: 1
    } : {
      opacity: 0
    }} transition={{
      duration: 1
    }} className="relative max-w-4xl mx-auto px-6 pt-16 pb-16 md:pt-28 md:pb-24" data-id="element-132">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="font-heading text-3xl md:text-5xl lg:text-[3.4rem] leading-tight md:leading-tight text-brand-gold text-center font-bold" data-id="element-133">
          ¿Por qué seguís en el mismo lugar aunque lo intentás todos los días?
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="font-heading text-lg md:text-xl text-brand-ivory/90 text-center mt-6 italic leading-relaxed max-w-3xl mx-auto" data-id="element-134">
          Porque nadie te dio el sistema completo. Hasta hoy.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="mt-10 space-y-5 text-brand-muted text-base md:text-lg leading-relaxed text-center max-w-2xl mx-auto font-body" data-id="element-135">
          <p data-id="element-136">El problema no es tu esfuerzo.</p>
          <p data-id="element-137">
            El problema es que estás usando piezas sueltas de un sistema que
            solo funciona completo.
          </p>
          <p data-id="element-138">
            Un video de manifestación aquí. Una afirmación allá. Una meditación
            que abandonás a la semana.
          </p>
          <p data-id="element-139">
            <strong className="text-brand-ivory" data-id="element-140">
              Mientras tanto tu subconsciente sigue corriendo el programa viejo
              las 24 horas.
            </strong>
          </p>
          <p className="text-brand-gold font-semibold text-lg md:text-xl" data-id="element-141">
            Hoy eso termina.
          </p>
        </motion.div>

        {/* Guarantee badge in hero */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 1.0
      }} className="mt-10 max-w-lg mx-auto" data-id="element-142">
          <div className="border border-brand-gold/20 rounded-lg bg-brand-guarantee/40 px-5 py-4 text-center" data-id="element-143">
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-144">
              <ShieldCheckIcon className="w-5 h-5 text-brand-gold" strokeWidth={1.5} data-id="element-145" />
              <span className="text-brand-gold font-body font-bold text-sm uppercase tracking-wider" data-id="element-146">
                Garantía total de 7 días
              </span>
            </div>
            <p className="text-brand-muted font-body text-sm leading-relaxed" data-id="element-147">
              Si en 7 días no es lo que esperabas, te devolvemos cada peso. Sin
              preguntas. Sin formularios. Solo un email y el reembolso es
              inmediato.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 1.2
      }} className="mt-10" data-id="element-148">
          <CTAButton text="→ ACCEDER AL SISTEMA POR $19.990 AHORA" showTrust={false} data-id="element-149" />
          <p className="text-brand-muted-dark text-xs tracking-wide text-center mt-4 max-w-md mx-auto leading-relaxed" data-id="element-150">
            🔒 Pago seguro por MercadoPago ✓ Descarga instantánea después del
            pago ✓ Garantía 7 días sin preguntas ✓ 390 páginas en 8 documentos
            PDF
          </p>
        </motion.div>
      </motion.div>

      <div className="h-px bg-gradient-to-r from-transparent via-brand-gold/40 to-transparent" data-id="element-151" />
    </section>;
}